import type { DeviceModel } from '../../types/deviceModel';
import { portRow, powerPort, simpleLayout } from './layoutHelpers';
import type { MultiFaceLayout } from '../../types';

export const injector24vModel: DeviceModel = {
  equipmentId: 'ubnt-poe-24',
  selfDrawWatts: 1,
  isInjector: true,
  powerInputs: [{ id: 'ac', kind: 'ac', portNumber: 1, face: 'back', maxWatts: 24 }],
  layout: {
    multiFace: {
      defaultFace: 'front',
      faces: {
        front: simpleLayout(
          [
            ...portRow({
              count: 1,
              startNumber: 1,
              kind: 'rj45',
              labelPrefix: 'LAN',
              speedsMbps: [10, 100, 1000],
              y: 22,
            }),
            ...portRow({
              count: 1,
              startNumber: 2,
              kind: 'rj45',
              labelPrefix: 'POE',
              speedsMbps: [10, 100, 1000],
              poeOut: {
                standards: ['passive-24'],
                perPortMaxWatts: 12,
                modeDefault: 'auto',
                poeOutOnlyWhenPoweredBy: ['ac'],
              },
              startX: 12 + 48,
              y: 22,
            }),
          ],
          180,
          70
        ),
        back: simpleLayout(
          [powerPort({ number: 1, kind: 'ac', label: 'AC in', x: 12, y: 20 })],
          140,
          70
        ),
      },
    } as MultiFaceLayout,
  },
};

export const injector60wModel: DeviceModel = {
  equipmentId: 'poe-injector-60w',
  selfDrawWatts: 1,
  isInjector: true,
  powerInputs: [{ id: 'ac', kind: 'ac', portNumber: 1, face: 'back', maxWatts: 60 }],
  layout: {
    multiFace: {
      defaultFace: 'front',
      faces: {
        front: simpleLayout(
          [
            ...portRow({
              count: 1,
              startNumber: 1,
              kind: 'rj45',
              labelPrefix: 'LAN',
              speedsMbps: [10, 100, 1000],
              y: 22,
            }),
            ...portRow({
              count: 1,
              startNumber: 2,
              kind: 'rj45',
              labelPrefix: 'POE',
              speedsMbps: [10, 100, 1000],
              poeOut: {
                standards: ['802.3af', '802.3at'],
                perPortMaxWatts: 60,
                modeDefault: 'auto',
                poeOutOnlyWhenPoweredBy: ['ac'],
              },
              startX: 12 + 48,
              y: 22,
            }),
          ],
          180,
          70
        ),
        back: simpleLayout(
          [powerPort({ number: 1, kind: 'ac', label: 'AC in', x: 12, y: 20 })],
          140,
          70
        ),
      },
    } as MultiFaceLayout,
  },
};
